import { all } from "redux-saga/effects";
import authSaga from "./auth/saga";
import chatMessagesSaga from "./chat/saga";
import chat from "./socket/saga";

export default function* rootSaga(getState: any) {
  yield all([chat(), authSaga(), chatMessagesSaga()]);
}
